import {ConfirmationCard} from 'presentation/pages/private/booking/components';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {formatText, getCityAndUfByRegex, getUfName} from 'presentation/utils';
import React from 'react';
import {CityCardProps} from './types';

const {appointmentCity} = translations['pt-br'].privateFlow.profile;

export function CityCard({flowType, formattedAddress}: CityCardProps) {
	const isOdonto = flowType === FlowEnum.ODONTO;

	const {district, city, uf} = getCityAndUfByRegex(formattedAddress);

	const showAddress = () => {
		if (isOdonto) {
			return {
				first: formatText(district),
				second: `${city}/${getUfName(uf)}`,
			};
		}
		return {
			first: formatText(city),
			second: `${getUfName(uf)}`,
		};
	};

	return (
		<ConfirmationCard.Root>
			<ConfirmationCard.Header subheader={appointmentCity} />
			<ConfirmationCard.Content
				iconName={'my-location-filled'}
				primaryText={showAddress().first}
				secondaryText={showAddress().second}
				secondaryTextColor="text.secondary"
			/>
		</ConfirmationCard.Root>
	);
}
